import { render, staticRenderFns } from "./UpdateNoCompany.vue?vue&type=template&id=1461a516&"
import script from "./UpdateNoCompany.vue?vue&type=script&lang=js&"
export * from "./UpdateNoCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports